import { Controller } from "@hotwired/stimulus";

const AMOUNT_COPY = {
  money: {
    label: "赠送金额（元）",
    hint: "默认不赠送，例如充 500 送 50 时填写 50",
  },
  count: { label: "总次数", hint: "填写整数，例如 20 次" },
  minute: { label: "总分钟数", hint: "填写整数，例如 600 分钟" },
};

// 新建套餐：权益按行增删，每行自己切换储值 / 次数 / 分钟的字段；
// 编辑套餐：没有权益行，只管「永久有效」开关。
export default class extends Controller {
  static targets = [
    "list",
    "template",
    "empty",
    "validityField",
    "validityInput",
    "unlimited",
  ];

  connect() {
    if (this.hasListTarget) this.update();
    else this.toggleValidity();
  }

  add() {
    this.listTarget.appendChild(this.templateTarget.content.cloneNode(true));
    this.update();
  }

  remove(event) {
    event.currentTarget.closest("[data-benefit-row]").remove();
    this.update();
  }

  update() {
    this.rows.forEach((row, index) => {
      this.reindexRow(row, index);
      this.updateRow(row);
    });
    if (this.hasEmptyTarget) this.emptyTarget.hidden = this.rows.length > 0;
    const needsValidity = this.rows.some((row) => this.unitOf(row) !== "money");
    this.validityFieldTarget.hidden = !needsValidity;
    if (needsValidity) this.toggleValidity();
    else this.validityInputTarget.disabled = true;
  }

  updateRow(row) {
    const unit = this.unitOf(row);
    const money = unit === "money";
    const product = row.querySelector("[data-benefit-product]");
    const amount = row.querySelector("[data-benefit-amount]");
    row.querySelector("[data-benefit-product-field]").hidden = money;
    product.required = !money;
    if (money) product.value = "";
    row.querySelector("[data-benefit-amount-label]").textContent =
      AMOUNT_COPY[unit].label;
    row.querySelector("[data-benefit-amount-hint]").textContent =
      AMOUNT_COPY[unit].hint;
    amount.min = money ? "0" : "1";
    amount.step = money ? "0.01" : "1";
    if (money && amount.value === "") amount.value = "0";
  }

  // 字段名 plan[benefits][<index>][…] 按行下标成组：模板克隆出来的是占位符，删行后也要重编号，
  // 否则服务端拿到的行会缺号或撞号。
  reindexRow(row, index) {
    row.querySelectorAll("[name]").forEach((field) => {
      field.name = field.name.replace(
        /\[benefits\]\[[^\]]*\]/,
        `[benefits][${index}]`,
      );
    });
  }

  toggleValidity() {
    this.validityInputTarget.disabled = this.unlimitedTarget.checked;
    this.validityInputTarget.required = !this.unlimitedTarget.checked;
    if (this.unlimitedTarget.checked) this.validityInputTarget.value = "";
  }

  get rows() {
    return [...this.listTarget.querySelectorAll("[data-benefit-row]")];
  }

  unitOf(row) {
    return row.querySelector("[data-benefit-unit]").value;
  }
}
